import React from "react";
import { isMobile } from "react-device-detect";

import { Box } from "@mui/material";

// Render a single plaque square.
// Memoized: a fast-chart page holds ~190 of these and a tap only changes one.
function Plaque(options = {}) {
    const {
        num,
        name,
        active = false,
        activeColor = "#1976d2",
        handleToggle,
        disabled = false,
        alternatingColors = false,
        fontSize = isMobile ? 9.5 : 11.5,
        squareSize = isMobile ? 15 : 20,
        backgroundColor = disabled ? "grey.900" : active ? activeColor : alternatingColors ? (num % 2 ? "background.secondary" : "background.primary") : "background.primary",
        textColor = disabled ? "grey.500" : active ? "#fff" : activeColor
    } = options;

    return (
        <Box
            key={name}
            sx={{
                width: squareSize,
                height: squareSize + 6,
                border: "1px solid #888",
                borderRadius: 1,
                bgcolor: backgroundColor,
                color: textColor,
                fontWeight: 500,
                fontSize: fontSize,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: disabled ? "default" : "pointer",
                opacity: disabled ? 0.5 : 1,
                mx: 0.1
            }}
            onClick={() => (disabled ? null : handleToggle(num, name))}>
            {name.toUpperCase()}
        </Box>
    );
}

export default React.memo(Plaque);
